import { render, staticRenderFns } from "./TaskHistoryComments.vue?vue&type=template&id=11fbe3c0&scoped=true"
import script from "./TaskHistoryComments.vue?vue&type=script&lang=js"
export * from "./TaskHistoryComments.vue?vue&type=script&lang=js"
import style0 from "./TaskHistoryComments.vue?vue&type=style&index=0&id=11fbe3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fbe3c0",
  null
  
)

export default component.exports